module.exports = __webpack_public_path__ + "static/media/var-analysis.678c4e4b.svg";